<template>
  <span
    class="min-w-6 flex h-6 w-6 items-center justify-center rounded-full bg-uiPrimary-400"
  >
    <slot />
  </span>
</template>
